exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("@tencent/docs-design-resources/icon/desktop/svg/membership_label_12.svg"));

// Module
exports.push([module.id, ".index-template-card-3Pcg7{width:62px;height:30px;padding:3px;display:flex;flex-wrap:wrap;justify-content:space-between;align-items:stretch;background:#fff;background-size:cover;border-radius:4px}.index-template-card-3Pcg7 .index-template-card-vip-icon-3z3Rx{width:10px;height:10px;background-image:url(" + ___CSS_LOADER_URL___0___ + ");background-size:contain;position:absolute;right:2px;bottom:2px}", ""]);

// Exports
exports.locals = {
	"template-card": "index-template-card-3Pcg7",
	"template-card-vip-icon": "index-template-card-vip-icon-3z3Rx"
};